(function ($, w) {
    $(function () {
        $.validator.addMethod(
            "phonenumber",
            function (value, element, params) {
                if (value) value = value.replace(/( |-|\(|\))/g, "");

                return new RegExp(params).test(value);
            },
            "A valid phone number is required"
        );
    });
})(jQuery, window);